import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../themes/typography';

const HeatmapLegend = ({ mode, onModeChange, minVal, maxVal, showToggle = true, categoryLegend, period = 30 }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      flexWrap: 'wrap'
    }}>
      {/* Category legend: colored swatches with labels */}
      {mode === 'category' && categoryLegend && categoryLegend.length > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          {categoryLegend.map((item) => (
            <Box key={item.name} sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Box sx={{
                width: 14,
                height: 14,
                borderRadius: '3px',
                backgroundColor: item.color,
                border: `1px solid ${colors.border.light}`,
                flexShrink: 0
              }} />
              <Typography sx={{ fontSize: '11px', color: colors.text.secondary, whiteSpace: 'nowrap' }}>
                {item.name}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default React.memo(HeatmapLegend);
